import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PlantillaService {

  navbarOpen = false;
  variable: string;

  constructor() {
  }

}
